import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
//SYSTEM1
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { TemplateStageModel } from "@/store/models/engagements/templateStage";
import { TemplateActivityModel } from "@/store/models/engagements/templateActivity";
import TemplatesModule from "@/store/modules/templates.module";
import { toaster } from "../../../utilities/toaster";
Component.registerHooks(["beforeRouteEnter"]);
setInteractionMode("passive");
let EngagementTemplate = /** @class */ (() => {
    let EngagementTemplate = class EngagementTemplate extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Engagement Templates";
            this.items = [
                {
                    text: "Home",
                    href: "#",
                },
                {
                    text: "Engagements",
                    href: "#",
                },
                {
                    text: "Engagement Templates",
                    active: true,
                },
            ];
            // DATA
            this.showTemplateStage = false;
            this.templateStage = new TemplateStageModel();
            this.stageModalTitle = "";
            this.showTemplateActivity = false;
            this.templateActivity = new TemplateActivityModel();
            this.activityModalTitle = "";
            this.selectedStageId = null;
            this.selectedActivityId = null;
        }
        async beforeRouteEnter(to, from, next) {
            await TemplatesModule.GetTemplateStages().then((response) => {
                next();
            });
        }
        // EVENT WIRINGS - STAGE
        openAddStageModal() {
            this.templateStage = new TemplateStageModel();
            this.templateStage.displayOrder = 0;
            this.showTemplateStage = true;
            this.stageModalTitle = "New Stage";
        }
        openEditStageModal(stageId) {
            this.templateStage = new TemplateStageModel();
            var stageData = this.templateStages.filter((x) => x.id == stageId)[0];
            this.templateStage = {
                id: stageData.id,
                stageName: stageData.stageName,
                isTenantVisible: stageData.isTenantVisible,
                description: stageData.description,
                activities: stageData.activities,
                displayOrder: stageData.displayOrder,
            };
            this.showTemplateStage = true;
            this.stageModalTitle = "Edit Stage";
        }
        closeStageModal() {
            this.showTemplateStage = false;
        }
        // EVENT WIRINGS - ACTIVITY
        openAddActivityModal(stageId) {
            this.selectedStageId = stageId;
            this.templateActivity = new TemplateActivityModel();
            this.templateActivity.displayOrder = 0;
            this.showTemplateActivity = true;
            this.activityModalTitle = "New Activity";
        }
        openEditActivityModal(stageId, activity) {
            this.selectedStageId = stageId;
            this.templateActivity = new TemplateActivityModel();
            this.templateActivity = {
                activityId: activity.activityId,
                activityDesc: activity.activityDesc,
                isTenantVisible: activity.isTenantVisible,
                baseline: activity.baseline,
                threshold: activity.threshold,
                displayOrder: activity.displayOrder,
            };
            this.showTemplateActivity = true;
            this.activityModalTitle = "Edit Activity";
        }
        closeActivityModal() {
            this.showTemplateActivity = false;
        }
        // CRUD
        saveTemplateStage() {
            this.validate("templateStageObserver").then((response) => {
                if (response) {
                    TemplatesModule.SaveTemplateStage(this.templateStage).then((response) => {
                        this.closeStageModal();
                        toaster.ShowApiSuccess(response);
                    });
                }
            });
        }
        removeStage(stageId) {
            this.selectedStageId = stageId;
        }
        closeModal(modalName) {
            var that = this;
            that.$root.$emit("bv::hide::modal", modalName);
        }
        deleteTemplateStage() {
            var that = this;
            TemplatesModule.DeleteTemplateStage(that.selectedStageId).then((response) => {
                this.closeModal("template-stage-delete");
                toaster.ShowApiSuccess(response);
            });
        }
        // EVENT WIRINGS - ACTIVITY
        saveTemplateActivity() {
            this.validate("templateActivityObserver").then((response) => {
                if (response) {
                    TemplatesModule.SaveTemplateActivity([this.selectedStageId, this.templateActivity]).then((response) => {
                        this.closeActivityModal();
                        toaster.ShowApiSuccess(response);
                    });
                }
            });
        }
        removeActivity(activityId) {
            this.selectedActivityId = activityId;
        }
        deleteTemplateActivity() {
            var that = this;
            TemplatesModule.DeleteTemplateActivity(this.selectedActivityId).then((response) => {
                this.closeModal("template-activity-delete");
                toaster.ShowApiSuccess(response);
            });
        }
        get templateStages() {
            return TemplatesModule.template;
        }
    };
    EngagementTemplate = __decorate([
        Component({
            name: "EngagementTemplate",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], EngagementTemplate);
    return EngagementTemplate;
})();
export default EngagementTemplate;
